import * as types from '../actions/types';

const initialState = {
  isError: false
};

const deactiveProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DEACTIVE_PROFILE_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.DEACTIVE_PROFILE_SUCCEEDED:
      return {
        ...state,
        error: null
      };
    case types.DEACTIVE_PROFILE_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    case types.CANCEL_COMMIT_OPTION_REQUEST:
      return {
        ...state,
        error: null
      };
    case types.CANCEL_COMMIT_OPTION_SUCCEEDED:
      return {
        ...state,
        error: null
      };
    case types.CANCEL_COMMIT_OPTION_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    case types.HIDE_ERROR:
      return {
        ...state,
        isError: false
      };
    default:
      return state;
  }
};

export default deactiveProfileReducer;
